import type { Prototype } from "../prototype-types";

export const kellyVonZupPrototypes: Prototype[] = [
  {
    id: "kvz-shipments-page",
    name: "Shipments Page",
    path: "/kvz/shipments-page",
    description:
      "New page for FbF Brands to view their inbound shipments to the Faire warehouse",
    owner: "Kelly Von Zup",
    createdAt: "2026-09-18",
    lastUpdated: "2026-09-18",
    surfaceArea: "Brand",
    category: "experimental",
    status: "in-progress",
    platform: "web",
    creationTool: "claude-code",
    thumbnail: "/images/thumbnails/kvz-shipments-page.png",
  },
  {
    id: "kvz-multi-location-inventory-product-editor",
    name: "Multi-Location Inventory: Product Editor",
    path: "/kvz/multi-location-inventory-product-editor",
    description: "Single Product Editor for any product, with Today, Expanded and Compact inventory layouts; Brand-managed On-Hand edits save to the shared store",
    project: "Multi-Location Inventory",
    owner: "Kelly Von Zup",
    createdAt: "2026-09-25",
    lastUpdated: "2026-09-25",
    surfaceArea: "Brand",
    category: "experimental",
    status: "in-progress",
    platform: "web",
    creationTool: "claude-code",
    thumbnail:
      "/images/thumbnails/kvz-multi-location-inventory-product-editor.png",
  },
  {
    id: "kvz-multi-location-inventory-page",
    name: "Multi-Location Inventory: Inventory Page",
    path: "/kvz/multi-location-inventory-page",
    description: "Brand Portal Inventory page in Today, Expanded and Compact layouts, reading and saving inventory, continue selling, pre-order and restock date through the shared store",
    project: "Multi-Location Inventory",
    owner: "Kelly Von Zup",
    createdAt: "2026-09-25",
    lastUpdated: "2026-09-25",
    surfaceArea: "Brand",
    category: "experimental",
    status: "in-progress",
    platform: "web",
    creationTool: "claude-code",
    thumbnail: "/images/thumbnails/kvz-multi-location-inventory-page.png",
  },
  {
    id: "kvz-bulk-product-edit",
    name: "Bulk Product Edit",
    path: "/kvz/bulk-product-edit",
    description: "Bulk Product Edit grid in Today, Expanded and Compact layouts, reading and saving inventory through the shared store",
    owner: "Kelly Von Zup",
    createdAt: "2026-10-05",
    lastUpdated: "2026-10-05",
    surfaceArea: "Brand",
    category: "experimental",
    status: "in-progress",
    platform: "web",
    creationTool: "claude-code",
    thumbnail: "/images/thumbnails/kvz-bulk-product-edit.png",
  },
  {
    id: "kvz-multi-location-inventory-demo",
    name: "Multi-Location Inventory: Demo Flow",
    path: "/kvz/multi-location-inventory-demo",
    description:
      "Clickable Brand Portal walkthrough starting at the Products page: Products, Single Product Editor, Bulk Edit and Inventory, with Today / Expanded / Compact layouts and inventory edits shared across pages",
    project: "Multi-Location Inventory",
    owner: "Kelly Von Zup",
    createdAt: "2026-10-12",
    lastUpdated: "2026-10-12",
    surfaceArea: "Brand",
    category: "experimental",
    status: "in-progress",
    platform: "web",
    creationTool: "claude-code",
    thumbnail: "/images/thumbnails/kvz-multi-location-inventory-demo.png",
  },
  {
    id: "kvz-multi-location-inventory-northstar",
    name: "Multi-Location Inventory: Northstar (Single Product Editor)",
    path: "/kvz/multi-location-inventory-northstar",
    description:
      "Northstar Single Product Editor: availability states, tracked inventory by stage and location, and how a product is sold, mapped onto the fields Brands enter today",
    project: "Multi-Location Inventory",
    owner: "Kelly Von Zup",
    createdAt: "2026-10-15",
    lastUpdated: "2026-10-15",
    surfaceArea: "Brand",
    category: "experimental",
    status: "in-progress",
    platform: "web",
    creationTool: "claude-code",
    thumbnail: "/images/thumbnails/kvz-multi-location-inventory-demo.png",
  },
  {
    id: "kvz-multi-location-inventory-spe-fbb",
    name: "Multi-Location Inventory: SPE Fulfilled by Brand",
    path: "/kvz/multi-location-inventory-spe-fbb",
    description:
      "Single Product Editor showing today's Fulfilled by Brand inventory view, with a note that Faire stock is managed separately",
    project: "Multi-Location Inventory",
    owner: "Kelly Von Zup",
    createdAt: "2026-10-21",
    lastUpdated: "2026-10-21",
    surfaceArea: "Brand",
    category: "experimental",
    status: "in-progress",
    platform: "web",
    creationTool: "claude-code",
    thumbnail: "/images/thumbnails/kvz-multi-location-inventory-product-editor.png",
  },
];
